module.exports = __webpack_public_path__ + "static/media/photo15.e4b7f6da.jpg";